import { Paper, styled } from '@mui/material';

export const Wrap = styled(Paper)(({ theme }) => ({
	display: 'flex',
	padding: '8px 16px',
	flexDirection: 'column',
	gap: '4px',
	minHeight: '56px',

	background: theme.palette.mode === 'dark' ? theme.palette.background.paper : '#fff',
	color: theme.palette.text.primary,
	position: 'relative',
	zIndex: 2,
}));

export const Info = styled('div')({
	display: 'flex',
	flexDirection: 'column',
});

export const TitleWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '4px',
	justifyContent: 'space-between',
});

export const BlockWrap = styled('div')({
	marginLeft: 'auto',
});
